// package imports:
import React from "react";
// component imports:
import Entrypoint from "../Entrypoint";
import Instructions from "../../components/DueDiligence/InstructionsPage";
import { DueDiligenceViewModel } from "../../types/DueDiligenceTypes";

const KnowYourCustomer: React.FC<DueDiligenceViewModel> = () => {
    return (
        <Entrypoint>
            <Instructions />
        </Entrypoint>
    )
};

export default KnowYourCustomer;